export const EMPLOYMENT_QUESTION_NYSE = 'questionNYSE';
export const EMPLOYMENT_QUESTION_DIRECTOR = 'questionDirector';
export const EMPLOYMENT_QUESTION_PRO = 'questionProfessional';
export const EMPLOYMENT_QUESTION_MARKET_DATA = 'questionMarketData';
export const EMPLOYMENT_QUESTION_REGISTERED_SECURITIES = 'questionRegisteredSecurities';
export const EMPLOYMENT_QUESTION_INVESTMENT_ADVISOR = 'questionInvestmentAdvisor';
